// ----------------------------------------------------------------------------
// Section: Sales Grid
// ----------------------------------------------------------------------------
//
// Filterable grid of Sale metaobject cards. Filtering is a simple class/attribute
// based show/hide scoped to a single <iam-sales-grid> instance.
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

import 'snippets/icon/icon';
import './_sales-grid.scss';

// -------------------------------------
// Web Component
// -------------------------------------

var FILTER = '.sales-grid__filter';
var CARD = '.sales-grid__card';
var ACTIVE_CLASS = 'is-active';
class iamSalesGrid extends HTMLElement {
  connectedCallback() {
    this.filterButtons = Array.from(this.querySelectorAll(FILTER));
    this.cards = Array.from(this.querySelectorAll(CARD));
    if (this.filterButtons.length === 0) return;
    this.filterButtons.forEach(button => {
      button.addEventListener('click', () => this.applyFilter(button));
    });
  }
  applyFilter(activeButton) {
    var filter = activeButton.dataset.filter;
    this.filterButtons.forEach(button => {
      var isActive = button === activeButton;
      button.classList.toggle(ACTIVE_CLASS, isActive);
      button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });
    this.cards.forEach(card => {
      var tags = (card.dataset.tag || '').split(' ').filter(Boolean);
      var isVisible = filter === 'all' || tags.includes(filter);
      card.toggleAttribute('hidden', !isVisible);
    });
  }
}
customElements.define('iam-sales-grid', iamSalesGrid);